module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-text-02579633e4c2bdb69f45d89643a97696.svg";